module.exports = __webpack_public_path__ + "img/pet_exchange.531afca4.png";